import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { Spinner } from '@/components/ui/spinner'
import { useUpdateDocumentTheme } from '@/services/queries/document_themes'

export const UpdateThemeButton = ({
  documentPageId,
  documentPageThemeId,
  themeName,
}: {
  documentPageId: string
  documentPageThemeId: string
  themeName: string
}) => {
  const { isPending, mutate: updateDocumentTheme } = useUpdateDocumentTheme()
  return (
    <DropdownMenuItem
      className="cursor-pointer"
      onClick={() =>
        updateDocumentTheme({
          documentPageId,
          documentPageThemeId,
          theme_type: 'operation',
          name: themeName,
        })
      }
    >
      {isPending ? (
        <>
          <Spinner /> Updating
        </>
      ) : (
        <span>Update using current operation</span>
      )}
    </DropdownMenuItem>
  )
}
